import { getExpiryAndDecodedToken, refreshAuthToken } from 'utils/Auth';

let timer: ReturnType<typeof setTimeout> | null = null;

/**
 * Initializes timer to refresh auth token, when the expiry is within a certain threshold
 * This gets called from 3 places:
 * 1. src/Routing/Layouts/RootLayout/utils/protectedRoute.loader.ts
 *  - this handles calling scheduleTokenCheck() when the user refreshes the page
 * 2. DB login success - in initAuthToken()
 * 3. SSO login success - in initAuthToken()
 * @returns void
 */
export const scheduleTokenCheck = (): void => {
  // Clear any existing timer
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  const tokenInfo = getExpiryAndDecodedToken();
  if (!tokenInfo) return;
  const { targetRefreshMs } = tokenInfo;

  timer = setTimeout(
    async (): Promise<void> => {
      try {
        await refreshAuthToken();

        // schedule the next check:
        scheduleTokenCheck();
      } catch (error) {
        // NOTE: user will be logged out if the request fails in refreshAuthToken()
        console.error('Error refreshing token:', error);
      }
    },
    Math.max(0, targetRefreshMs)
  );
};
